import { render } from "./TrainedByCourse.vue?vue&type=template&id=13b30de6&scoped=true"
import script from "./TrainedByCourse.vue?vue&type=script&lang=js"
export * from "./TrainedByCourse.vue?vue&type=script&lang=js"

import "./TrainedByCourse.vue?vue&type=style&index=0&id=13b30de6&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b30de6"]])

export default __exports__